import {
  FOC_TOUR_LABEL_RES_214,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_RES_214_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  FOC_REQUIRED_DISPOSITION,
  focResTourPopoverHtml,
  requirement,
  type FocResTourStepDef,
} from './focResTourTypes';

export const FOC_RES_214_TOUR_PARAM = 'focRes214Tour';
export const FOC_RES_214_TOUR_HREF = HREF;
export { focResTourPopoverHtml };

export const FOC_RES_214_TOUR_IAP_PARAM = 'focRes214Tour';

export function focRes214TourIapHref(incidentId: string): string {
  return `/iap/${incidentId}/activity-logs?${FOC_RES_214_TOUR_IAP_PARAM}=1`;
}

export const FOC_RES_214_TOUR_STEPS: FocResTourStepDef[] = [
  {
    id: 'sectionIntro',
    surface: 'activityLog',
    tour: 'resources-activity-log',
    title: FOC_TOUR_LABEL_RES_214,
    description:
      'ICS 214 activity logs give every authorized incident user a persistent, rapid-entry log reachable from the incident workspace—with submission, archive, and revision controls.',
  },
  requirement({
    id: 'res005',
    requirementId: 'FOC-RES-005',
    name: 'Persistent ICS 214 Quick-Action Log',
    disposition: FOC_REQUIRED_DISPOSITION,
    surface: 'activityLog',
    tour: 'resources-activity-log',
    description:
      'Authorized incident users get a persistent, rapid-entry activity-log capability from their relevant workspace without navigating to a separate documentation-only page.',
    bullets: [
      'FOC-RES-005a — Prefill from roster, org chart, assignments, home unit, and other authorized records; manual entry and correction remain available.',
      'FOC-RES-005b — Daily/shift submission, reminders, Documentation Unit collection, review, archive, export, revision history, and audit controls.',
      'FOC-RES-005c — Submitted records are preserved with documented revision controls; PRATUS does not silently overwrite submitted ICS 214 records.',
    ],
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_RES_214),
  },
];

export function focRes214TourNavVisible(enabled: boolean): boolean {
  return enabled;
}

export function focRes214TourStepIds(): string[] {
  return FOC_RES_214_TOUR_STEPS.map((step) => step.id);
}
